// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter_option_list{
    width: var(--space-and-half);
    justify-content: center;
    align-items: center;
}

.filter_option_list_card{
    width: 30%;
    list-style: none;
    position: absolute;
    z-index: 1;
    top: 42%;
    left: 48%;
    background: var(--white-color);
    box-shadow: 0px 0.470693px 16.4742px rgba(116, 116, 116, 0.25);
    border-radius: 5px;
    padding: 0;
}

.filter_option_list_card li{
    padding: var(--space-and-half);
    justify-content: flex-start;
}

.container_filter_option_list {
    padding: var(--space);
}

.filter_option_list_card_title{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: var(--space);
}

.filter_option_list_card_title .baloa-names{
    color: var(--primary-very-dark-color);
}

.filter-button_clean {
    color: var(--new-green-color);
}

.filter_option_list_option_body_form_date{
    display: flex;
}

.filter_option_list_option_button{
    display: flex;
    justify-content: flex-end;
}

.filter_option_list_body_select .select-field-input{
    background: var(--white);
    border: 1px solid #E7E7E7;
    box-sizing: border-box;
    border-radius: 8px;
    margin-bottom: var(--space-half);
    height: var(--space-x2);
}

.filter_option_list_body_select .select-field-label{
    font-size: 12px;
    line-height: 14px;
    color: var(--primary-very-dark-color);
}

.filter_option_list_body_select .MuiInput-underline:before {
    border-bottom: none;
}

.filter_option_list_body_select .MuiSelect-selectMenu{
    font-size: 13px;
    color: var(--basic-gray-color);
}

.filter_option_list_body_input.input-field{
    margin: var(--space) 0;
    margin-right: var(--space);
}

.filter_option_list_body_input .input-field-label{
    font-size: 12px;
    line-height: 14px;
    color: var(--primary-very-dark-color);
}

.filter_option_list_body_input .input-field-input{
    background: var(--white-color);
    border: 1px solid #E7E7E7;
    box-sizing: border-box;
    border-radius: 8px;
    font-size: 13px;
    padding: var(--space-half);
}

.filter_option_list_body_input_search .input-field-auto-search{
    margin: var(--space-and-half) 0 !important;
}

.filter_option_list_body_input_search .input-field-autocomplete-search label{
    font-size: 12px;
    line-height: 14px;
    color: var(--primary-very-dark-color);
}

.filter_option_list_body_input_search .input-field-autocomplete-search input {
    height: var(--space-x2);
    font-size: 12px;
    line-height: 14px;
}

.filter_option_list_body_input_search .input-field-autocomplete-search div{
    border-radius: calc( var( --space-half ) + 1px );
    background: var(--white);
    border: 1px solid #E7E7E7;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-tournament-filter/LeagueTournamentFilterComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,8DAA8D;IAC9D,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gDAAgD;IAChD,wBAAwB;IACxB,yBAAyB;AAC7B","sourcesContent":[".filter_option_list{\n    width: var(--space-and-half);\n    justify-content: center;\n    align-items: center;\n}\n\n.filter_option_list_card{\n    width: 30%;\n    list-style: none;\n    position: absolute;\n    z-index: 1;\n    top: 42%;\n    left: 48%;\n    background: var(--white-color);\n    box-shadow: 0px 0.470693px 16.4742px rgba(116, 116, 116, 0.25);\n    border-radius: 5px;\n    padding: 0;\n}\n\n.filter_option_list_card li{\n    padding: var(--space-and-half);\n    justify-content: flex-start;\n}\n\n.container_filter_option_list {\n    padding: var(--space);\n}\n\n.filter_option_list_card_title{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: var(--space);\n}\n\n.filter_option_list_card_title .baloa-names{\n    color: var(--primary-very-dark-color);\n}\n\n.filter-button_clean {\n    color: var(--new-green-color);\n}\n\n.filter_option_list_option_body_form_date{\n    display: flex;\n}\n\n.filter_option_list_option_button{\n    display: flex;\n    justify-content: flex-end;\n}\n\n.filter_option_list_body_select .select-field-input{\n    background: var(--white);\n    border: 1px solid #E7E7E7;\n    box-sizing: border-box;\n    border-radius: 8px;\n    margin-bottom: var(--space-half);\n    height: var(--space-x2);\n}\n\n.filter_option_list_body_select .select-field-label{\n    font-size: 12px;\n    line-height: 14px;\n    color: var(--primary-very-dark-color);\n}\n\n.filter_option_list_body_select .MuiInput-underline:before {\n    border-bottom: none;\n}\n\n.filter_option_list_body_select .MuiSelect-selectMenu{\n    font-size: 13px;\n    color: var(--basic-gray-color);\n}\n\n.filter_option_list_body_input.input-field{\n    margin: var(--space) 0;\n    margin-right: var(--space);\n}\n\n.filter_option_list_body_input .input-field-label{\n    font-size: 12px;\n    line-height: 14px;\n    color: var(--primary-very-dark-color);\n}\n\n.filter_option_list_body_input .input-field-input{\n    background: var(--white-color);\n    border: 1px solid #E7E7E7;\n    box-sizing: border-box;\n    border-radius: 8px;\n    font-size: 13px;\n    padding: var(--space-half);\n}\n\n.filter_option_list_body_input_search .input-field-auto-search{\n    margin: var(--space-and-half) 0 !important;\n}\n\n.filter_option_list_body_input_search .input-field-autocomplete-search label{\n    font-size: 12px;\n    line-height: 14px;\n    color: var(--primary-very-dark-color);\n}\n\n.filter_option_list_body_input_search .input-field-autocomplete-search input {\n    height: var(--space-x2);\n    font-size: 12px;\n    line-height: 14px;\n}\n\n.filter_option_list_body_input_search .input-field-autocomplete-search div{\n    border-radius: calc( var( --space-half ) + 1px );\n    background: var(--white);\n    border: 1px solid #E7E7E7;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
